<template>
  <div>
    <!-- Story Modal -->
    <b-toast
        id="story-sidebar-toast-skip"
        toast-class="story-sidebar-toast-wrapper"
        body-class="story-sidebar-toast"
        :visible="showSkipToast"
        :auto-hide-delay="5000"
        :no-close-button="true"
        @hidden="showSkipToast=false"
      >
        Story skipped to end, click Argo for training options
    </b-toast>
    <b-modal
      id="story-modal"
      hide-header
      hide-footer
      size="lg"
      :modal-class="'story-modal-component'"
    >
      <div class="story-modal">
        <img v-if="Progression.storyIndex < Object.keys(storyInstructions.affiliates[Progression.stepIndex].story).length - 1" class="confirm-next-button-image-1" src="./assets/panel-next-button.png"/>
        <button
          v-if="Progression.storyIndex < Object.keys(storyInstructions.affiliates[Progression.stepIndex].story).length - 1"
          class="confirm-next-button-1"
          @click="replacePanelText"
        >
        continue
        </button>
        <button
          v-else
          class="confirm-next-button-2"
          @click="completePanelText"
        >
          <img class="confirm-next-button-image-2" src="./assets/panel-confirm-button.png"/>
        </button>
        <typewriter ref="typewriter" class="typewriter" :type-interval="1" :replace-interval="1">
          <div class="typewriter-text">
            {{storyInstructions.affiliates[Progression.stepIndex].story[Progression.storyIndex]}}
          </div>
        </typewriter>
        <button class="skip-button" @click="skipStoryProgress">
          skip
        </button>
      </div>
    </b-modal>

    <b-container fluid>
      <b-row>
        <b-col class="mt-4" lg="9" >
          <img
            class="zoombies-logo"
            src="https://zoombies.world/images/zoombies_coin.svg"
          />
          <h4 class="main-pink-title"> Zoombies Affiliate Dashboard</h4>
        </b-col>
        <b-col :style="{textAlign: 'center'}" lg="3" >
          <img class="affiliate-icon" src="./assets/affiliate_icon.png"/>
          <h4 class="pink-subtitle"> Last Affiliate Joined:</h4>
          <h4 v-b-tooltip.hover.bottom class="white-subtitle underline">
              &nbsp;{{
                lastAffJoined ?
                (lastAffJoined.affiliate.substr(0, 6) +
                "..." +
                lastAffJoined.affiliate.substr(38))
                :
                "Loading"
              }}
            </h4>
          <h4 class="white-subtitle">
            {{formatDate(lastAffJoined.blockTimestamp)}}
          </h4>
        </b-col>
      </b-row>

      <!-- MAIN BODY of affiliates page housing graph table and top information boxes -->
      <b-row>
        <b-col lg="12">
          <div class="body-container mt-5">
            <b-row>
              <b-col lg="3" md="12" sm="12">
                <h4 class="main-pink-title my-network-title"> My Network </h4>
                <button
                  class="add-button"
                  @click="showSponsorModal"
                >
                  <img id="affiliate-dialog-button-popover"
                    class="add-button-image"
                    src="https://zoombies.world/images/dapp/green_button_400.webp"
                  />
                  <span
                    class="add-button-text"
                  >
                    Add Affiliates
                  </span>
                </button>
                <button
                    class="link-button"
                    @click="copyProfileLink"
                  >
                    <img
                      class="link-button-image"
                      src="https://zoombies.world/images/dapp/grey_button_400.webp"
                    />
                    <span
                      class="link-button-text"
                    >
                      Copy Link
                  </span>
                </button>
              </b-col>
              
              <b-col lg="3" md="12" sm="12">
                <div class="sub-container total-affs mt-3" :style="{float:'right'}">
                  <img class="box-icon" src="./assets/affiliate_icon.png"/>
                  <h4 id="my-affiliates-popover" class="box-title" :style="{color: '#FF19B1'}"> My Total Affiliates </h4>
                  <h4 class="box-title box-number" >{{parseInt(userTotalAffs).toLocaleString()}}</h4>
                </div>
              </b-col>

              <b-col lg="3" md="12" sm="12">
                <div class="sub-container mt-3">
                  <img class="box-icon" src="https://zoombies.world/images/zoombies_coin.svg"/>
                  <h4 id="my-zoom-popover" class="box-title" :style="{color: '#00D1FF'}"> My Total Zoom Earned </h4>
                  <h4 class="box-title box-number" > {{parseInt(userTotalAffZoomEarned).toLocaleString()}} </h4>
                </div>
              </b-col>

              <b-col ref="myNetworkData" lg="3" md="12" sm="12" >
                <div class="sub-container top-earner mt-3 " >
                  <h4 id="my-topzoom-popover" class="box-title" :style="{color: '#FF19B1'}"> My Top Affiliate </h4>
                    <h4 v-b-tooltip.hover.bottom :class="{ 'white-subtitle':true, 'underline':true, 'uninteractable':(userTopZoomEarner == null || userTopZoomEarner.id == '')}"
                    :title="getWalletAddress" @click="redirectOthersDashboard(userTopZoomEarner)">
                      &nbsp;{{ 
                        userTopZoomEarner.id != "" && userTopZoomEarner?
                        userTopZoomEarner.id.substr(0, 6) +
                        "..." +
                        userTopZoomEarner.id.substr(38)
                        : "No Affiliates Linked"
                      }}
                    </h4>
                  <h4  ref="globalNetworkData" class="box-title box-number" :style="{fontSize: '40px'}"> 
                  {{parseInt(userTopZoomEarner.zoomEarned).toLocaleString()}} 
                  </h4>
                  <img class="box-icon" src="https://zoombies.world/images/zoombies_coin.svg"/>
                  <h4 class="box-title">Zoom Earned</h4>
                </div>
              </b-col>
            </b-row>
            
            <b-row>
              <b-col lg="5"> <!-- chart -->
                <div class="mt-5">
                  <b-row>
                    <b-col lg="8">
                      <h4 id="my-graph-popover" class="pink-subtitle"> Affiliates / Zoom Earned </h4>
                    </b-col>

                    <b-col lg="4">
                      <b-form-select v-model="selectedOption">
                        <b-form-select-option value="all">All time</b-form-select-option>
                        <b-form-select-option value="week">Past week</b-form-select-option>
                        <b-form-select-option value="month">Past month</b-form-select-option>
                      </b-form-select>
                    </b-col>
                  </b-row>

                  <affiliate-chart :selected_option="selectedOption" />
                </div>
              </b-col>
              <b-col lg="5" class="offset-lg-1">
                <affiliate-table :latest_earnings="latestEarnings" :latest_affs="latestAffs"/>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <!-- BOTTOM ROW of Affiliates page -->
      <b-row>
        <b-col lg="12">
          <div class="body-container mt-5">
            <h4 id="global-network-popover" class="main-pink-title"> Global Network </h4>       
            <b-row>
              <b-col lg="2" class="px-1 m-1">
                <div class="sub-container">
                  <h4 id="global-sponsor-popover" class="box-title" :style="{color:'#757AFF'}">Total Sponsors</h4>
                  <h4 class="box-title box-number">{{parseInt(totalSponsors).toLocaleString()}}</h4>
                </div>
              </b-col>
              <b-col lg="2" class="px-1 m-1">
                <div class="sub-container">
                  <h4 id="global-affiliates-popover" class="box-title" :style="{color:'#FF19B1'}">Total Affiliates</h4>
                  <h4 class="box-title box-number">{{parseInt(totalAffiliates).toLocaleString()}}</h4>
                </div>
              </b-col>
 
              <b-col lg="3" class="px-1 m-1">
                <div class="sub-container">
                  <img class="box-icon" src="https://zoombies.world/images/zoombies_coin.svg"/>
                  <h4 id="global-zoom-earned-popover" class="box-title" :style="{color: '#00D1FF'}"> Total Zoom Generated </h4>
                  <h4 class="box-title box-number" > {{parseInt(totalAffZoomEarned).toLocaleString()}} </h4>
                </div>
              </b-col>
              <b-col lg="2" class="px-1 mx-2 my-1">
                <div class="sub-container" >
                  <h4 id="global-top-zoom-popover" class="box-title" :style="{color: '#00F955'}"> Top Zoom Earner </h4>
                    <h4 v-b-tooltip.hover.bottom class="white-subtitle underline" :class="{ 'white-subtitle':true, 'underline':true, 'uninteractable':(topZoomEarner == null || topZoomEarner.id == '')}"
                    @click="redirectOthersDashboard(topZoomEarner)">
                      &nbsp;{{
                        topZoomEarner ?
                        (topZoomEarner.id.substr(0, 6) +
                        "..." +
                        topZoomEarner.id.substr(38))
                        :
                        "Loading"
                      }}
                    </h4>
                  <h4 class="box-title box-number"> 
                  {{parseInt(topZoomEarner.rewardTotal).toLocaleString()}} 
                  </h4>
                  <img class="box-icon" src="https://zoombies.world/images/zoombies_coin.svg"/>
                  <h4 class="box-title">Zoom Earned</h4>
                </div>
              </b-col>
              <b-col lg="2" class="px-1 mx-2 my-1">
                <div class="sub-container" >
                  <h4 id="global-top-sponsor-popover" class="box-title" :style="{color: '#FF0A54'}"> Top Sponsor </h4>
                    <h4 v-b-tooltip.hover.bottom class="white-subtitle underline" :class="{ 'white-subtitle':true, 'underline':true, 'uninteractable':(topSponsor == null || topSponsor.id == '')}"
                    @click="redirectOthersDashboard(topSponsor)">
                      &nbsp;{{
                        topSponsor ?
                        (topSponsor.id.substr(0, 6) +
                        "..." +
                        topSponsor.id.substr(38))
                        :
                        "Loading"
                      }}
                    </h4>
                  <h4 class="box-title box-number" > {{parseInt(topSponsor.affiliateCount).toLocaleString()}} </h4>
                  <h4 class="box-title">Affiliates Linked</h4>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>        
      </b-row>

    </b-container>
    <b-popover :show="Progression.stepIndex==2 && Progression.storyIndex==1" target="my-affiliates-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[2].popovers[1].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==2 && Progression.storyIndex==2" target="my-zoom-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[2].popovers[2].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==2 && Progression.storyIndex==3" target="my-topzoom-popover" triggers="manual" placement="right" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[2].popovers[3].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==2 && Progression.storyIndex==4" target="my-graph-popover" triggers="manual" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[2].popovers[4].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==3 && Progression.storyIndex==1" target="global-network-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[3].popovers[1].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==3 && Progression.storyIndex==2" target="global-sponsor-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[3].popovers[2].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==3 && Progression.storyIndex==3" target="global-affiliates-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[3].popovers[3].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==3 && Progression.storyIndex==4" target="global-zoom-earned-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[3].popovers[4].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==3 && Progression.storyIndex==5" target="global-top-zoom-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[3].popovers[5].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==3 && Progression.storyIndex==6" target="global-top-sponsor-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[3].popovers[6].content }}
      </div>
    </b-popover>
    <b-popover :show="Progression.stepIndex==3 && Progression.storyIndex==8" target="affiliate-dialog-button-popover" triggers="manual" placement="left" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.affiliates[3].popovers[8].content }}
      </div>
    </b-popover>
  </div>
</template>

<script>
  import './assets/global.css';
  import{
    BContainer,
    BRow,
    BCol,  
    BFormSelect,
    BFormSelectOption,
    BPopover
  } from "bootstrap-vue"
  import { mapGetters } from "vuex"
  import AffiliateTable from './charts/AffiliateTable.vue'
  import AffiliateChart from "./charts/AffiliateChart.vue"
  import { showErrorToast, showSuccessToast } from "../util/showToast";
  import Typewriter from "typewriter-vue";
  import Progress from './Progress.js';
  import storyInstructions from "./story-instructions.json";
  import { Progression } from './Progression.js'

  export default {
    name: "AffiliateDashboard",
    components:{ 
      BContainer,
      BRow,
      BCol,
      BFormSelect,
      BFormSelectOption,
      AffiliateTable,
      AffiliateChart,
      Typewriter,
      BPopover
    },

    data () {
      return {
        storyInstructions,
        Progression,
        stepIndex: 1,
        showSkipToast: false,
        walletId: "",
        lastAffJoined: "",
        
        //Top Row Number Variables
        userTotalAffs: 0,
        userTotalAffZoomEarned: 0,  
        topUserAffEarnings: 0,
        userTopZoomEarner: {id: "", zoomEarned: 0},
        latestAffs: [],
        latestEarnings: [],

        //Bottom Row Number Variables 
        topZoomEarner: {id: "", zoomEarned: 0},
        totalSponsors: 0,
        totalAffiliates: 0,
        totalAffZoomEarned: 0,
        topAffEarnings: 0,
        topSponsorAffs: 0,
        topSponsor: {id: "", affiliateCount: 0},
        selectedOption: "all", //for the graph
      };
    },

    computed: {
      ...mapGetters({
        getWalletAddress: "blockChain/getWalletAddress"})
    },
    watch: {
      getWalletAddress(val, oldVal) {
        if (val && oldVal && val !== oldVal) {
          showSuccessToast(this, "Successfully changed wallets.");
        }
      },
    },
    created() {
      this.ProgressInstance = new Progress();

      const progress = this.ProgressInstance.getProgress();

      if (progress.hasOwnProperty('affiliates')) {
        Progression.stepIndex = progress.affiliates;
      } else {
        Progression.stepIndex = 1;
      }

      this.ProgressInstance.updateProgress({name: 'affiliates', value: Progression.stepIndex});
      },
    mounted() {
      this.$root.$on('bv::popover::show', bvEventObj => {
        Progression.popOverSound.play();
      })

      this.$nextTick(() => {
        Progression.storyIndex = 0;

        const progress = this.ProgressInstance.getProgress();

        if (progress.hasOwnProperty('affiliates')) {
          Progression.stepIndex = progress.affiliates;
        } else {
          Progression.stepIndex = 1;
        }

        if (progress.affiliatesCompleted === false) {
          Progression.popOverSound.play();
          Progression.typingSound.currentTime = 83;
          Progression.typingSound.play();
          this.$bvModal.show('story-modal');
        }
      })

      this.querySubGraph();
    },
    methods: {
      redirectOthersDashboard(obj) {
        if (obj == null) return;
        this.$router.push({
          name: "OthersAffiliateDashboard",
          params: { address: obj.id },
        });
      },
      replacePanelText: async function() {

        if (Progression.storyIndex < storyInstructions.affiliates[Progression.stepIndex].story.length - 1) {

          Progression.typingSound.currentTime = (Math.random() * 3) + 82;
          Progression.typingSound.play();

          this.$refs.typewriter.replaceText({
            from: storyInstructions.affiliates[Progression.stepIndex].story[Progression.storyIndex],
            to: storyInstructions.affiliates[Progression.stepIndex].story[Progression.storyIndex + 1],
          });
        }

        Progression.storyIndex++;

        //Scroll bottom into view
        if(Progression.stepIndex == 2 && Progression.storyIndex == 1) {
          console.log("scrolling");
          this.$refs.myNetworkData.scrollIntoView({ behavior: 'smooth' });
        }
        if(Progression.stepIndex == 3 && Progression.storyIndex == 1) {
          this.$refs.globalNetworkData.scrollIntoView({ behavior: 'smooth' });
        }
        if(Progression.stepIndex == 3 && Progression.storyIndex == 7) {
          this.$refs.myNetworkData.scrollIntoView({ behavior: 'smooth' });
        }

      },
      completePanelText: async function() {
          this.$bvModal.hide('story-modal');

          Progression.stepIndex++;

          this.ProgressInstance.updateProgress({name: 'affiliates', value: Progression.stepIndex});

          if (Progression.stepIndex > Object.keys(storyInstructions.affiliates).length) {
            Progression.stepIndex = Object.keys(storyInstructions.affiliates).length;
            this.ProgressInstance.updateProgress({name: 'affiliates', value: Progression.stepIndex});

            this.ProgressInstance.updateProgress({name: 'affiliatesCompleted', value: true});
            Progression.storyIndex = 999; // placeholder value
            Progression.storyCompletedSound.play();
          } else {
            Progression.progressStepSound.play();
            this.$bvModal.show('story-modal');
            Progression.storyIndex = 0; // placeholder value
            this.ProgressInstance.updateProgress({name: 'affiliatesCompleted', value: false});
          }
      },
      skipStoryProgress() {
          this.showSkipToast = true;

          Progression.stepIndex = Object.keys(storyInstructions.affiliates).length;// Specific for this page
          Progression.storyIndex = 0;
          this.ProgressInstance.updateProgress({name: 'affiliates', value: 1});
          this.completePanelText();
      },
      showSponsorModal() {
        this.$bvModal.show("sponsor-modal");
      },
      copyProfileLink() {
        const link = this.getDashboardLink(this.getWalletAddress);
        try {
          navigator.clipboard.writeText(link);
          showSuccessToast(this, "Link to dashboard copied to clipboard");
        }
        catch (error) {
          console.error(error);
          showErrorToast(this, `Failed to copy link to clipboard: ${link}`);
        }
      },
      getDashboardLink(walletAddress) {
        let url;
              
        if (process.env.NODE_ENV === "development") {
          url = "http://localhost:8080";
        } else {
          url = "https://zoombies.world";
        }

        let curr_chain;
        if(window.ethereum.networkVersion == 1287) {
          curr_chain = 'moonbase';
        }
        else if(window.ethereum.networkVersion == 1284) {
          curr_chain = 'moonbeam';
        }

        return `${url}/${curr_chain}/affiliate-dashboard/${walletAddress}`;
      },

      formatDate (timeStamp) {
        if (timeStamp){
          timeStamp.toString();
          return (timeStamp.substr(0,4) + "/" + timeStamp[5] + timeStamp[6] + "/" + timeStamp[8] + timeStamp[9])
        }
        else{
          return "Loading";
        }
      },
      querySubGraph: async function () {
        const query = `query {
          sponsorAffiliateCounts( orderBy: AFFILIATE_COUNT_DESC){
            nodes {
              id
              affiliateCount
            }
          }
          sponsorRewardTotals(orderBy: REWARD_TOTAL_DESC) {
            nodes {
              id     
              rewardTotal
            }
          }
          logSponsorLinkeds(orderBy: BLOCK_TIMESTAMP_DESC){
            nodes {
              id
              blockTimestamp
              sponsor
              affiliate
            }
          }
          logSponsorRewards (orderBy: BLOCK_TIMESTAMP_DESC) {
            nodes {
              id
              blockTimestamp
              sponsor
              affiliate
              zoomReward
            }
          }
        }
        `;
        const graphEndPoint = "https://cryptoz.cards:3000"

        try {
          const result = await fetch(
            graphEndPoint,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body:JSON.stringify({
                query
                }),
            }
          );
          const res = await result.json();

          //variables to simplify the JSON obj returned from the query
          const sponsorAffiliateCounts = res.data.sponsorAffiliateCounts.nodes; 
          const sponsorRewardTotals = res.data.sponsorRewardTotals.nodes;
          const logSponsorLinkeds = res.data.logSponsorLinkeds.nodes;
          const logSponsorRewards = res.data.logSponsorRewards.nodes;
          const userSponsorLinkeds = logSponsorLinkeds.filter(node => node.sponsor == this.getWalletAddress);
          const userSponsorRewards = logSponsorRewards.filter(node => node.sponsor == this.getWalletAddress); 
          
          //Computing Variables
          var userRewards = []; // used to get "My Total Affiliates" and "My Top Zoom Earner" values
          var userTotalZoom = 0;
          var totalAff = 0;
          var totalZoom = 0;
          var latestAffCount = 0;
          var latestEarningsCount = 0;
          
          userSponsorRewards.map((node)=>{
            latestEarningsCount++;
            //Latest Earnings
            if (latestEarningsCount < 6 && node && node.blockTimestamp && node.affiliate) {
              this.latestEarnings.push(
              {
                date: this.formatDate(node.blockTimestamp), 
                affiliate: node.affiliate.substr(0,6) + "..." + node.affiliate.substr(38), 
                zoom_earned: parseInt(node.zoomReward).toLocaleString(),
              })}
            var unique = true;
            for (var item of userRewards) {
              
              if (node && (item.affiliate == node.affiliate)){
                unique = false;
                item.zoomEarned = Number(item.zoomEarned) + Number(node.zoomReward);
              }
            }
            if (unique == true) userRewards.push({affiliate: node.affiliate, zoomEarned: node.zoomReward})
          })
          
          sponsorAffiliateCounts.map((node)=>{
            totalAff += parseInt(node.affiliateCount);
            
            if (node.id == this.getWalletAddress){
              this.userTotalAffs = node.affiliateCount; 
            }
          })

          if (this.userTotalAffs != 0){
            userSponsorLinkeds.map((node)=>{
            latestAffCount++;
            if (latestAffCount < 6 && node && node.affiliate) {
              this.latestAffs.push(
              {
                date_linked: this.formatDate(node.blockTimestamp), 
                affiliate_address: node.affiliate.substr(0,6) + "..." + node.affiliate.substr(38)
              });}
            })
          }
          
          res.data.sponsorRewardTotals.nodes.map((node)=>{
            totalZoom += parseInt(node.rewardTotal);
            if (this.userTotalAffs != 0){
              if (node.id == this.getWalletAddress){
              this.userTotalAffZoomEarned = node.rewardTotal;
            }}
          })

          //Variable assignment for values in the bottom row and the last affiliate joined
          this.lastAffJoined = res.data.logSponsorLinkeds.nodes[0];
          this.totalAffZoomEarned = totalZoom;      
          this.totalAffiliates = totalAff;
          this.totalSponsors = sponsorAffiliateCounts.length; 
          this.topSponsor = sponsorAffiliateCounts[0];
          this.topZoomEarner = sponsorRewardTotals[0];

          //Variable assignment for values in the top row (User specific data)
            //Lambda to sort the user's affiliate list by zoom earned in descending order to populate "My Top Zoom Earner"
            function compare(a,b) {
              if (a.zoomEarned < b.zoomEarned){
                return -1;
              }
              if (a.zoomEarned > b.zoomEarned){
                return 1;
              }
              return 0;
            }
          
          if (this.userTotalAffs != 0){
            userRewards.sort(compare);
            this.userTopZoomEarner= {id: userRewards[0].affiliate, zoomEarned: userRewards[0].zoomEarned};
          }
          else{
            this.userTopZoomEarner={id: "", zoomEarned: 0}
          }
        } catch (err){
          console.log("Error from Affiliate Dashboard Query: ", err);
        }
      },
    },
  }
  
</script>

<style lang="scss" scoped>

.main-pink-title {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 600;
  font-size: 42px;
  line-height: 68px;

  text-transform: uppercase;

  color: #dc78ff;

  text-shadow: 4px 8px 4px rgba(0, 0, 0, 0.25);
  display:inline-flex;
}

.my-network-title {
  display: block;
}

.pink-subtitle {
  font-family: "Truculenta", sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 30px;
  text-transform: uppercase;
  color: #dc78ff;

  display: inline-flex;

  text-shadow: 4px 8px 4px rgba(0, 0, 0, 0.25);
}

.container {
  padding-top: 20px;
}

.zoombies-logo {
  display:inline-flex;
  transform: translate(-20%, -17%);
  width: 7%;
  height: auto;
}

.affiliate-icon {
  display:inline-flex;
  transform: translate(-20%, -17%);
  width: 10%;
  height: auto;
}

.white-subtitle {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
}

.underline {
  text-decoration: underline;
}

.white-subtitle.underline:hover {
  color: #0056b3;
}

.uninteractable {
  pointer-events: none;
}

.body-container {
  border: 3px #00D1FF solid;
  background-color: rgba(30,22,47,80%); 
  border-radius: 25px;
  
  width: 100%;
  height: auto;

  padding: 3%;
}

.sub-container {
  border-radius: 25px;
  border: 3px #00D1FF solid;
  background-color: #1E162F; 
  text-align: center;
  padding: 7% 2%;
}

.box-title{
  font-family: "Truculenta", sans-serif;
  font-weight: 700;
  font-size: 26px;
  text-transform: uppercase;

  display:inline-flex;
}

.box-icon {
  display:inline-flex;
  transform: translate(-20%, -13%);
  width: 14%;
  height: auto;
}

.box-number {
  font-size: 30px;
  display: block; 
}

.top-earner { //styling for the My Top Zoom Earner box
  width: 100%;
}

.total-affs { //styling for the My Total Affiliates box
  width: 100%;
}

.add-button {
  background-color: transparent;
  border-color: transparent;
  position: relative;
  display: inline-block;
  margin-left: 0;
  margin-right: 0;
}

.add-button:hover, .link-button:hover {
  transform: scale(1.05);
}

.add-button-image {
  height: 60px;
  width: 168px;
}

.add-button-text, .link-button-text {
  color: #000000;
  white-space: nowrap;
  font-family: 'Truculenta', sans-serif;
  font-weight: 700;
  font-size: 20px;
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.link-button {
  background-color: transparent;
  border-color: transparent;
  position: relative;
  display: inline-block;
  margin-left: 0;
  margin-right: 0;
}

.link-button-image {
  height: 60px;
  width: 120px;
}

@media (min-width: 1050px){
  .white-subtitle {
    font-size: 22px;
  }
  .box-number {
    font-size: 35px;
  }
}

@media (min-width: 1405px){
  .box-number{
    font-size: 45px
  }
  .total-affs {
    width: 90%;
  }
  .top-earner {
    width: 80%;
  }
}


</style>